import React, { Component } from "react";
import Button from "../../../../shared/button/button";
import Input from "../../../../shared/Input/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { validateCPF } from "../../../../../js/shared/validation-utils";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import {
	setDataToStoreParticipant,
	onSearchByCPFParticipant,
	onApproveInvite,
	cleanSearchManagerByCpf,
	ifRenderModalInvalidCPF
} from "./../../../actions/account-link";
import Callout from "./../../../../shared/Callout/Callout";
import Modal from "./../../../../shared/Modal/Modal";
import InputSearch from "../../../../shared/InputSearch/InputSearch";
import Loading from "../../../../shared/Loading/Loading";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AccountLinkSearch extends Component {
	constructor() {
		super();
		this.state = {
			cpfValidated: undefined,
			cpfInput: undefined,
			errors: {},
			openModalInvalidCPF: false
		};

		this.validateCpf = this.validateCpf.bind(this);
		this.nextStep = this.nextStep.bind(this);
		this.prevStep = this.prevStep.bind(this);
	}

	isValid() {
		return false;
	}

	validateCpf(raw, value) {
		const { errors } = this.state;

		let length = value.length;
		let isCPFValid = validateCPF(value);
		if (length < 14 || !isCPFValid) {
			errors.cpf = undefined;
		} else {
			errors.cpf = "";
		}

		this.setState({ cpfInput: value, errors });
	}

	onApproveInvite = () => {
		this.props.onApproveInvite(this.props.dataApproveInvite);
	};

	nextStep() {
		this.props.incStep(this.state);
	}

	prevStep() {
		this.props.cleanSearchManagerByCpf();
		this.props.decStep(this.state);
	}

	onRenderModalInvalidCPF = () => {
		if (this.props.renderModalInvalidCPF && !this.state.openModalInvalidCPF) {
			this.setState({
				openModalInvalidCPF: true
			});
		} else {
			this.setState({
				openModalInvalidCPF: false
			});
		}
	};

	render() {
		const { cpfInput, errors, openModalInvalidCPF } = this.state;
		const {
			onSearchByCPFParticipant,
			dataApproveInvite,
			searched,
			isInvalidCPF,
			isFailureLimitReached,
			ifRenderModalInvalidCPF,
			dataToSendParticipant,
			renderModalInvalidCPF,
			isOneLessAttempt,
			isLoading
		} = this.props;

		return (
			<React.Fragment>
				<div className="account-link-search">
					{isMobile() ? (
						<React.Fragment>
							<h4>Vínculo de conta</h4>
							<label className="account-link-search--gestor-cpf">CPF do Gestor</label>
							<div className="account-link-search--details">
								<div className="col-xs-16 no-padding no-margin">
									<div className="col-xs-16 no-padding no-margin">
										<InputSearch
											autoComplete="off"
											name="cpf"
											value={cpfInput}
											pattern="\d*"
											inputMode="numeric"
											onFocus={this.onRenderModalInvalidCPF}
											maskpattern={"999.999.999-99"}
											onChange={this.validateCpf}
											disabled={isFailureLimitReached}
											onSearch={() =>
												onSearchByCPFParticipant(cpfInput, dataToSendParticipant.relationId)
											}
											isDisabled={errors.cpf != "" || isLoading.onSearchByCPFParticipant}
											required
										/>
									</div>
									{!searched && dataApproveInvite ? (
										<div className="col-xs-16 no-padding no-margin account-link-search--manager-found">
											<p>Gestor encontrado!</p>
											<div className="account-link-search--manager-found-info">
												<div>
													<label>Nome</label>
													<p>{dataApproveInvite.name}</p>
												</div>
												<div>
													<label>Cidade</label>
													<p>{dataApproveInvite.city}</p>
												</div>
											</div>
										</div>
									) : null}
								</div>
							</div>
						</React.Fragment>
					) : (
						<React.Fragment>
							<h5>Confirmação da identidade do gestor</h5>

							<p>Informe o CPF do gestor que te indicou e solicite o vínculo de conta.</p>

							<label>CPF do gestor</label>

							<div className="account-link-search--details">
								<Input
									autoComplete="off"
									name="cpf"
									value={cpfInput}
									pattern="\d*"
									inputMode="numeric"
									disabled={isFailureLimitReached}
									maskpattern={"999.999.999-99"}
									onChange={this.validateCpf}
									onFocus={this.onRenderModalInvalidCPF}
									required
								/>
								<div>
									<Button
										className="btn-primary-lg"
										disabled={
											errors.cpf != "" ||
											isFailureLimitReached ||
											isLoading.onSearchByCPFParticipant
										}
										type="button"
										onClick={() => {
											onSearchByCPFParticipant(cpfInput, dataToSendParticipant.relationId)
											publish(eventType.ACCOUNT_FAMILY, {
												type: ACCOUNT_FAMILY_EVENT.button_confirm_search
											})
										}
										}
									>
										{isLoading.onSearchByCPFParticipant ? (
											<Loading width="20px" height="20px" />
										) : (
											"Confirmar"
										)}
									</Button>
								</div>
								{!searched && dataApproveInvite ? (
									<div className="account-link-search--manager-found">
										<p>Gestor encontrado!</p>
										<div className="account-link-search--manager-found-info">
											<div>
												<label>Nome</label>
												<p>{dataApproveInvite.name}</p>
											</div>
											<div>
												<label>Cidade</label>
												<p>{dataApproveInvite.city}</p>
											</div>
										</div>
									</div>
								) : null}
							</div>
						</React.Fragment>
					)}
					<Callout
						show={isInvalidCPF && !isFailureLimitReached && !isOneLessAttempt}
						warn
						text={
							<span>
								<strong>CPF não encontrado ou inválido.</strong> Você só tem mais duas tentativa
								hoje. Digite novamente com atenção.
							</span>
						}
					/>
					<Callout
						show={isInvalidCPF && isFailureLimitReached}
						danger
						icon="close"
						text={
							<span>
								<strong>O CPF digitado não foi encontrado</strong> e você excedeu o limite de 3
								tentativas por dia. Sua indicação foi invalidada.
							</span>
						}
					/>
					<Callout
						show={isInvalidCPF && !isFailureLimitReached && isOneLessAttempt}
						warn
						text={
							<span>
								<strong>CPF não encontrado ou inválido.</strong> Você só tem mais uma tentativa
								hoje. Digite novamente com atenção.
							</span>
						}
					/>
				</div>
				<Modal
					show={renderModalInvalidCPF && openModalInvalidCPF}
					fixed
					confirm="Entendi"
					title="Atenção!"
					onConfirm={() => ifRenderModalInvalidCPF()}
					description={
						<span>
							Você só tem <strong>mais uma tentativa</strong> para digitar o CPF corretamente. Caso
							exceda esse número, esta indicação será invalidada.
						</span>
					}
				/>
				<div className="row-botoes--search-management">
					<div className="text-right">
						<Button className="btn-gray-lg-label" onClick={this.prevStep} type="button">
							Cancelar
						</Button>
						<Button
							className="btn-primary-lg"
							disabled={!dataApproveInvite}
							onClick={() => {
								this.nextStep();
								publish(eventType.ACCOUNT_FAMILY, {
									type: ACCOUNT_FAMILY_EVENT.button_accept_and_advance
								})
							}}
							type="button"
						>
							Avançar
						</Button>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	...state.accountLink,
	searched: state.accountLink.isLoading.onSearchByCPFParticipant
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setDataToStoreParticipant,
			onSearchByCPFParticipant,
			onApproveInvite,
			cleanSearchManagerByCpf,
			ifRenderModalInvalidCPF
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkSearch);
